// extracted by mini-css-extract-plugin
export default {"buttonStyle":"styles_buttonStyle__19oeI","imgStyle":"styles_imgStyle__Okuax"};